import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutRevenueCode } from "./autogen/AutogenLayoutRevenueCode";

export class RevenueCode extends AutogenLayoutRevenueCode {
    override onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "revenue_code",
            screenName: this.titleSingular,
            navigateToUrl: `${this.layoutName}?mode=update&key=`
        });
    }
}
